// src/services/paymentService.js

export const getPaymentDetails = () => {
    return new Promise((resolve) => {
        // Mock payment details
        setTimeout(() => {
            resolve({
                cardLast4: '1234',
                expiry: '12/24'
            });
        }, 500); // Simulate network delay
    });
};

export const getPaymentHistory = () => {
    return new Promise((resolve) => {
        // Mock payment history
        setTimeout(() => {
            resolve([
                {
                    date: '2024-08-20',
                    amount: 49.99,
                    status: 'Paid',
                },
                {
                    date: '2024-07-15',
                    amount: 29.99,
                    status: 'Paid',
                },
                {
                    date: '2024-06-10',
                    amount: 19.99,
                    status: 'Paid',
                },
            ]);
        }, 500); // Simulate network delay
    });
};
